// @flow

import unifizeUser from "./index";
import LastLoggedIn from "src/components/user/LastLoggedIn";

export default unifizeUser(LastLoggedIn);
